import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class categoriesList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return `
            
            <div class="list-header w-justify" >

                <div class="w-left" data-bind="if: isAddButtonShown">
                    <button data-bind="click: onClickShowPopUp" class="btn secondary icon i-add" type="button">Create Category</button>
                </div>

                <div class="w-center">
                         ` + this.filter.getHtmlBuild() + `
                </div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>

                        </tr>
                    </thead>
                    <tbody data-bind="foreach: categories">
    
                        <tr>
                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: id"></span></td>
                            <td data-bind="event: { click: $parent.onClickView }"><span data-bind="text: name"></span></td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>   
            
            
          <div id="create-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Create Category</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <label class="form-label">Name</label>
                                <div class="w-input">
                                    <input type="text" name="name" id="name"  class="input-text" data-bind="value: name">
                                </div>
                            </div>
                        </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            
            
            
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string {
        return "categoriesList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            orderBy: ko.observable("name")
            , orderByDirection: ko.observable("ASC")
            , categories: ko.observableArray([])
            , orderByAndDirection: ko.observable("name_ASC")
            , isAddButtonShown: ko.observable(true)
            , name : ko.observable()
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickSave: function () {
                huit_neuf_this.onClickSave();
            },
            onClickShowPopUp: function () {
                huit_neuf_this.onClickShowPopUp()
            },
            onClickHidePopUp: function () {
                huit_neuf_this.onClickHidePopUp()
            },
        };
    }

    // category save model
    public buildCategoryViewModel(){

        return {

            name: this.getTemplateViewModel().name
        }

    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            ,filters      : {
                keywords : this.getTemplateViewModel().filter.filterKeyword,
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.categoryListReorder();
    }

    public onClickSave() {

        this.toggleDeleteDialogVisibility();
        this.caller.saveCategory();
    }

    public onClickShowPopUp() {

        this.toggleDeleteDialogVisibility();
    }

    public onClickHidePopUp() {

        this.toggleDeleteDialogVisibility();
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('create-dialog').classList.toggle('is-visible');
    }

    public setCategories(categories) {

        this.getTemplateViewModel().categories(categories);
    }

    public setAddButtonShown(isAddButtonShown: boolean) {

        this.getTemplateViewModel().isAddButtonShown(isAddButtonShown);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/categoriesList_template.ts